import { Outlet, createFileRoute, useRouterState } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { UpdateViewPage } from "@/pages/dashboard/updates/view";

/**
 * Update detail. `$id/edit` is a child of this route — render `<Outlet />`
 * when editing so the form mounts instead of this view.
 */
export const Route = createFileRoute("/_main/dashboard/updates/$id")({
  component: () => (
    <RequirePermission action="updates.read">
      <UpdateIdLayout />
    </RequirePermission>
  ),
});

function UpdateIdLayout() {
  const showingChild = useRouterState({
    select: (state) => state.matches.some((match) => match.routeId.endsWith("/edit")),
  });
  if (showingChild) return <Outlet />;
  return <UpdateViewPage />;
}
